import React, { useEffect, useState } from "react";
import { Modal, Form, Flex } from "antd";
import CustomSelect from "../../../Reuseable/Select/Select";
import "./RulesEditModal.scss";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import { fetchRulesList } from "../../../store/rulesSlice";

const RulesEditModal = ({
  open,
  onClose,
  userData = {},
  onSave,
  editableRule,
  bankListOption,
  productListOption,
  areaCodeListOption,
  bucketOptions,
  languageOptions,
}) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({
    id: editableRule?.key,
    team: null,
    bucket: null,
    language: null,
    bank: [],
    product: [],
    area: [],
  });

  const handleChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (editableRule) {
      setFormValues({
        id: editableRule.key,
        team: editableRule.name,
        bucket: editableRule.bucket,
        language: editableRule.language,
        bank: editableRule.portfolio?.map((item) => item.id),
        product: editableRule.product?.map((item) => item.id),
        area: editableRule.area?.map((item) => item.id),
      });
    }
  }, [editableRule]);

  const handleEditRules = async () => {
    const payload = {
      id: editableRule?.key,
      bucket: formValues.bucket,
      portfolio: formValues.bank,
      product: formValues.product,
      area: formValues.area,
      language: formValues.language,
    };

    try {
      const res = await axios.patch("agency/admin/permissions-list/", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.status === 200) {
        CustomNotification.show("Rules updated successfully!", "success");
        onClose();
        dispatch(fetchRulesList());
      }
    } catch (error) {
      CustomNotification.show("Error updating rules", "error");
      console.error(error);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable
      destroyOnClose
      className="rules-edit-modal"
    >
      <h3 className="modalTitle">
        Edit User Rules <span>of {formValues.team}</span>
      </h3>
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: userData?.name,
          address: userData?.address,
          operationalAreas: userData?.area,
          mobile: userData?.mobile,
        }}
      >
        <Flex className="select-and-input">
          <Flex className="select-item">
            <CustomSelect
              label="Banks"
              placeholder="Select Bank"
              value={formValues.bank}
              options={bankListOption}
              onChange={(value) => handleChange("bank", value)}
              isMultiSelect={true}
            />
            <CustomSelect
              label="Products"
              placeholder="Select Product"
              value={formValues.product}
              options={productListOption}
              onChange={(value) => handleChange("product", value)}
              isMultiSelect={true}
            />
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Area"
              value={formValues.area}
              options={areaCodeListOption}
              onChange={(value) => handleChange("area", value)}
              isMultiSelect={true}
            />
          </Flex>
          <Flex className="inputs">
            <CustomSelect
              placeholder=" select"
              label="Bucket Range Start"
              className="formSelect"
              value={formValues.bucket}
              options={bucketOptions}
              onChange={(value) => handleChange("bucket", value)}
            />
            <CustomSelect
              placeholder="select"
              label="Language"
              className="formSelect"
              value={formValues.language}
              options={languageOptions}
              onChange={(value) => handleChange("language", value)}
            />
          </Flex>
        </Flex>

        <Form.Item>
          <NormalButton
            type="primary"
            className="saveDetailsBtn"
            onClick={handleEditRules}
          >
            Save Details
          </NormalButton>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RulesEditModal;
